import React, { useState } from 'react';
import Footer from '../components/Footer';
import '../styles/favorite.css';
import { LeftOutlined } from '@ant-design/icons';
import { Input, Select, Button } from 'antd';
import Product from '../components/Product';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getFavorites } from '../redux/ecommerce/favoriteSlice';
import { useTranslation } from 'react-i18next';

const { Search } = Input;

const Favorites = () => {

    const { t, i18n } = useTranslation();
    const { language } = i18n;

    const [visibleProducts, setVisibleProducts] = useState(6);

    const dispatch = useDispatch();

    const { favorites, status } = useSelector(
        (state) => state.favourite
    );

    useEffect(() => {
        dispatch(getFavorites());
    }, [dispatch]);

    const onSearch = (value, _e, info) => console.log(info?.source, value);

    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };

    const loadMore = () => {
        setVisibleProducts((prev) => prev + 6);
    };



    return (
        <div className='favorites'>
            <div className='bg-[#FCFBFA]'>
                <div className='px-20 max-lg:px-5'>
                    <Link to='/' className='flex items-center text-[#283D63] text-lg py-10 max-lg:py-5 font-semibold'>
                        <LeftOutlined />
                        <p className='ml-2'>Back to home</p>
                    </Link>
                    <div className='lg:flex justify-between items-center pb-7'>
                        <h3 className='text-[#14294F] text-2xl font-semibold'>My Favourites</h3>
                        <Search
                            placeholder='Search for a product'
                            onSearch={onSearch}
                            className='text-[#FE9B71] w-[330px] max-lg:w-full h-[50px] relative z-10 text-xl max-lg:text-lg max-lg:mt-5'
                        />
                    </div>
                </div>
            </div>
            <div className='px-20 max-lg:px-5 mt-10 pb-10'>
                <div className='flex items-center'>
                    <p className='mr-3 text-[#283D63] font-semibold'>Sort:</p>
                    <Select
                        defaultValue='Recommended'
                        style={{
                            width: 190,
                        }}
                        className='border-2 border-[#4F71A8]'
                        onChange={handleChange}
                        options={[
                            {
                                value: 'Recommended',
                                label: 'Recommended',
                            },
                            {
                                value: 'Best_sellers',
                                label: 'Best Sellers',
                            },
                        ]}
                    />
                </div>
                <div className='grid grid-cols-3 max-lg:grid-cols-1 gap-20 px-8 max-lg:px-5 my-7'>
                    {/* {Array(visibleProducts).fill().map((_, index) => (
                        <Product key={index} />
                    ))} */}
                    {/* {favorites
                        ?.slice(0, visibleProducts)
                        ?.map((product) => (
                            <Product
                                key={product.id}
                                id={product.id}
                                color_id={product.colors[0]?.id || null}
                                count={1}
                                image={`https://ecommerce.samoolah.com${product.image}`}
                                name={language === "en" ? product.name_en : product.name_ar}
                                price={product.price}
                                link={product.id}
                                favorite={product.favorite}
                            />

                        ))} */}


                    {favorites?.slice(0, visibleProducts)?.map((product) => (
                        <Product
                            key={product.id}
                            id={product.id}
                            color_id={product.colors?.[0]?.id || null}
                            count={1}
                            image={`https://ecommerce.samoolah.com${product.image}`}
                            name={language === "en" ? product.name_en : product.name_ar}
                            price={product.price}
                            link={product.id}
                            favorite={product.favorite}
                        />
                    ))}

                </div>
                {(visibleProducts > 12) && (
                    <div className='flex justify-center'>
                        <Button type='primary' onClick={loadMore} className='bg-[#FE9B71] px-14 py-6 rounded-full text-xl' style={{ background: "#FE9B71" }}>
                            Load More
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Favorites;
